import Route from '@ember/routing/route';

export default class EnServicesRoute extends Route {
  // Parent route for services namespace - inherits locale from 'en' route
}




